// @anchormgtbda Instagram feed — add new posts to the top of this list as they're published.
// Easiest flow: upload image to /app/frontend/public, then reference the local path here.

export const INSTAGRAM_HANDLE = "anchormgtbda";
export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;

export const INSTAGRAM_POSTS = [
  {
    id: "launch",
    image: "/instagram-1.png",
    url: "https://www.instagram.com/p/DX3eiXflgTj/",
    caption:
      "Ahoy, friends and fellow adventurers. We are thrilled to introduce you to Anchor Management, our newest pride and joy — a 35ft Bavaria sailboat that embodies both elegance and impeccable functionality.",
    callout: "Ready for the adventure?",
  },
];
